<aura-dialog-layout [title]="data.title ?? 'Patch entity state'">
  <div dialog-body class="flex flex-col gap-4">
    <div>
      Are you sure you want to change this {{ data.label || 'entity' | lowercase }} status to
      <span class="font-bold uppercase text-primary">
        {{ data.status | stateStatusDisplay }}
      </span>
      ?
    </div>

    <aura-entity-state-form
      [dto]="data"
      [isAdmin]="data.isAdmin ?? true"
      (validityChanged)="onValidityChanged($event)"
      (dtoChanged)="onDtoChanged($event)"
    />

    @if (data.status === entityStatus.DELETED && data.deletionConfirmation) {
      <mat-form-field class="w-full">
        <mat-label class="text-red">Veuillez saisir "DELETE" </mat-label>
        <input matInput [(ngModel)]="confirmInput" autocomplete="off" />
        @if (confirmInput() && confirmInput() !== confirmText) {
          <mat-error> Le texte doit être exactement "{{ confirmText }}" </mat-error>
        }
      </mat-form-field>
    }
  </div>

  <div dialog-actions>
    <button mat-button class="destructive" [disabled]="!isValid()" (click)="onConfirm()">
      {{ data.confirm?.text || 'Confirm' }}
    </button>
  </div>
</aura-dialog-layout>
